import { Component, OnInit, TemplateRef } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../services/toaster.service';
import { CommonService } from '../services/common.service';
import { PlatformLocation } from '@angular/common';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-refer-articles',
  templateUrl: './refer-articles.component.html',
  styleUrls: ['./refer-articles.component.css'],
  providers: [ToasterService,CommonService]
})
export class ReferArticlesComponent implements OnInit {
  modalRef: BsModalRef;
  articleInfoSection: boolean = true;
  articleListSection: boolean;
  loading: boolean;
  error: any;
  articleData: {};
  data:{};
  likeCount: any;
  name:any;
  email: any;
  mobile: any;
  articleId: any;
  f: any;
  productId: any;
  cityList: any = [];
  noResult = false;
  typeheaderResult : any=[];
  cityValue: void;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private serviceURLService: serviceURLService, private modalService: BsModalService, public toasterService: ToasterService, public commonService : CommonService, private platformLocation: PlatformLocation) {
    platformLocation.onPopState(() => {
      this.modalRef.hide();
    });
   }

  ngOnInit() {
    this.getArticlesData();
    this.isReferMoreClick();
    this.getCities();
  }

  

  getArticlesData(){
    this.loading = true;
      var userId = localStorage.getItem("userID")
      this.serviceURLService.getArticlesData(userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.articleData = successData.response;
        for(var i=0;i<this.articleData[i].length;i++){
          this.articleId = this.articleData[i]._id;
          this.productId = this.articleData[i].linkedToproductType;
        }
        this.loading =false;
      }, errorData => {
        console.log("Oops..!! there is some error in downloading pdf", errorData);
        if (errorData.error.status === 403) {
          this.error = errorData.error.message;
        }
      })
  }

  isReferMoreClick(){
    var checkState = localStorage.getItem("backToPrevious");
    if(checkState){
      this.articleInfoSection = false;
      this.articleListSection = true;
      setTimeout(() => {
        localStorage.removeItem("backToPrevious");
      }, 1000);
    }else{
      this.articleInfoSection = true;
      this.articleListSection = false;
    }
  }

  //call on like button click
  likeArticle(articleId){
    this.data = {
      "articleID":articleId
    }
    var userId = localStorage.getItem("userID")
    this.serviceURLService.sendLikeCount(this.data,userId).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      console.log("Liked Successfully");
      this.likeCount = successData.response.likeCount;
      this.getArticlesData();
    }, errorData => {
      console.log("Oops..!! there is some error in downloading pdf", errorData);
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
        this.toasterService.showErrorToaster(this.error);
      }else if (errorData.error.status === 400) {
        // this.error = errorData.error.message;
        this.toasterService.showErrorToaster("You can give upto 50 likes.");
      }
    })
  }

  shareArticle(productId,f,articleId){
    this.loading = true;
    this.data = {
      "name":f.name,
      "email":f.email,
      "mobile":f.mobile,
      "productName":articleId,
      "ProductID":productId,
      "source":"Notify-Article",
      "city":f.location
    }
    var userId = localStorage.getItem("userID")
    this.serviceURLService.saveReferral(userId,this.data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      this.router.navigate(['refer-success']);
    }, errorData => {
      console.log("Oops..!! there is some error in downloading pdf", errorData);
      if (errorData.error.status === 403) {
        this.loading = false;
        this.error = errorData.error.message;
        this.toasterService.showErrorToaster(this.error);
      }else if (errorData.error.status === 400) {
        this.loading = false;
        this.toasterService.showErrorToaster("Please try another number.");
      }
    })
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-lg modal-dialog-centered', ignoreBackdropClick: false});
  }

  getCities() {
    this.loading = true;
    this.serviceURLService.getCities().pipe(takeUntil(this.onDestroy$)).subscribe(
        (success: any) => {
        this.loading = false;
        this.cityList = success.data.cityList;
        }, error => {
        this.loading = false;
        }
    )
  }

  selectCity(event: TypeaheadMatch): void {
    this.noResult = this.commonService.onSelectCity(event);
  }

  checkCityValue(event): void {
    this.noResult = this.commonService.checkCityValue(event,this.cityList);
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

}
